export function formatDateToDDMMYYYY(date: Date): string {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export function parseDDMMYYYYToEpoch(dateStr: string): number {
  const [dd, mm, yyyy] = dateStr.split('/').map(Number);
  const date = new Date(yyyy, mm - 1, dd); // Months are 0-based
  return date.getTime(); // returns milliseconds since epoch
}

export function formatUtcDateToDDMMYYYY(date: Date): string {
  const dd = String(date.getUTCDate()).padStart(2, '0');
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = date.getUTCFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
